import { render, staticRenderFns } from "./MerchantDivision.vue?vue&type=template&id=49b89889&scoped=true"
import script from "./MerchantDivision.vue?vue&type=script&lang=ts"
export * from "./MerchantDivision.vue?vue&type=script&lang=ts"
import style0 from "./MerchantDivision.vue?vue&type=style&index=0&id=49b89889&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b89889",
  null
  
)

export default component.exports